import { Col, Row } from "antd";
import { CloseBtn } from "../Buttons";
import { Modal } from "./Modal";
import { TableUi } from "../TableUi";
export const DetallePreviewModal = ({
  data,
  rowKey = "id",
  columns,
  open,
  onCancel,
}) => {
  return (
    <Modal
      title="Detalle"
      open={open}
      onCancel={onCancel}
      width="50%"
      footer={[<CloseBtn key="back" onClick={onCancel} />]}
    >
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <TableUi
            data={data || []}
            columns={columns}
            rowKey={rowKey}
            size="small"
          />
        </Col>
      </Row>
    </Modal>
  );
};
